module.exports = __webpack_public_path__ + "static/media/20201114_161913_841_IMG_0029.4abcd4ae.jpg";